import { useState, useContext } from "react";
import { Link, NavLink } from "react-router-dom";
import { useAuthState } from "react-firebase-hooks/auth";
import { signOut } from "firebase/auth";
import { auth } from "../firebase";
import { clearKeyCache } from "../utils";
import { EncryptionContext } from "./EncryptionContext";

function MobileNav({ activeTab, setTab }) {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [user] = useAuthState(auth);
  const { setPassphrase } = useContext(EncryptionContext);

  const handleLogout = () => {
    signOut(auth);
    localStorage.removeItem("passphrase");
    localStorage.removeItem("userUid");
    setPassphrase("");
    clearKeyCache();
    setIsMenuOpen(false);
  };

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <>
      <button
        className="md:hidden fixed top-4 right-4 z-20 p-2 rounded-md bg-white/10 backdrop-blur-md text-text-dark"
        onClick={toggleMenu}
      >
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d={isMenuOpen ? "M6 18L18 6M6 6l12 12" : "M4 6h16M4 12h16M4 18h16"}
          />
        </svg>
      </button>

      <div
        className={`md:hidden fixed top-0 right-0 z-10 h-full w-64 bg-gradient-to-br from-nav-from to-nav-to p-4 shadow-lg transform transition-transform duration-300 ${
          isMenuOpen ? "translate-x-0" : "translate-x-full"
        }`}
      >
        <div className="flex flex-col gap-4 w-full">
          <h1 className="text-3xl font-bold text-text-dark text-center w-full mt-12">66 Days Journal</h1>
          <NavLink
            to="/"
            onClick={() => setIsMenuOpen(false)}
            className={({ isActive }) =>
              `tab w-full text-center px-4 py-2 rounded-md ${
                isActive ? "bg-neutral text-white" : "tab-inactive hover:bg-secondary hover:text-white"
              } transition-colors`
            }
          >
            Home
          </NavLink>
          <NavLink
            to="/blog"
            onClick={() => setIsMenuOpen(false)}
            className={({ isActive }) =>
              `tab w-full text-center px-4 py-2 rounded-md ${
                isActive ? "bg-neutral text-white" : "tab-inactive hover:bg-secondary hover:text-white"
              } transition-colors`
            }
          >
            Blog
          </NavLink>
          <NavLink
            to="/about"
            onClick={() => setIsMenuOpen(false)}
            className={({ isActive }) =>
              `tab w-full text-center px-4 py-2 rounded-md ${
                isActive ? "bg-neutral text-white" : "tab-inactive hover:bg-secondary hover:text-white"
              } transition-colors`
            }
          >
            About
          </NavLink>
          {user && (
            <NavLink
              to="/cms"
              onClick={() => setIsMenuOpen(false)}
              className={({ isActive }) =>
                `tab w-full text-center px-4 py-2 rounded-md ${
                  isActive ? "bg-neutral text-white" : "tab-inactive hover:bg-secondary hover:text-white"
                } transition-colors`
              }
            >
              CMS
            </NavLink>
          )}
          {setTab ? (
            <button
              onClick={() => {
                setTab("cycles");
                setIsMenuOpen(false);
              }}
              className={`tab w-full text-center px-4 py-2 rounded-md ${
                activeTab === "cycles"
                  ? "bg-neutral text-white"
                  : "tab-inactive hover:bg-secondary hover:text-white"
              } transition-colors`}
              aria-current={activeTab === "cycles" ? "page" : undefined}
            >
              Cycles
            </button>
          ) : (
            <NavLink
              to="/cycles"
              onClick={() => setIsMenuOpen(false)}
              className={({ isActive }) =>
                `tab w-full text-center px-4 py-2 rounded-md ${
                  isActive ? "bg-neutral text-white" : "tab-inactive hover:bg-secondary hover:text-white"
                } transition-colors`
              }
            >
              Cycles
            </NavLink>
          )}
          {user && (setTab ? (
            <button
              onClick={() => {
                setTab("settings");
                setIsMenuOpen(false);
              }}
              className={`tab w-full text-center px-4 py-2 rounded-md ${
                activeTab === "settings"
                  ? "bg-neutral text-white"
                  : "tab-inactive hover:bg-secondary hover:text-white"
              } transition-colors`}
              aria-current={activeTab === "settings" ? "page" : undefined}
            >
              Settings
            </button>
          ) : (
            <NavLink
              to="/settings"
              onClick={() => setIsMenuOpen(false)}
              className={({ isActive }) =>
                `tab w-full text-center px-4 py-2 rounded-md ${
                  isActive ? "bg-neutral text-white" : "tab-inactive hover:bg-secondary hover:text-white"
                } transition-colors`
              }
            >
              Settings
            </NavLink>
          ))}
          {user ? (
            <button
              onClick={handleLogout}
              className="btn-secondary flex items-center justify-center gap-2 text-sm w-full"
            >
              <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                <path d="M3 3a2 2 0 00-2 2v12a2 2 0 002 2h7v-2H3V5h7V3H3zm10 3a1 1 0 00-.707.293l-4 4a1 1 0 000 1.414l4 4a1 1 0 001.414 0l.707-.707L11.414 12l4.293-4.293a1 1 0 00-.707-1.707H13z" />
              </svg>
              Log Out
            </button>
          ) : (
            <Link
              to="/cycles"
              onClick={() => setIsMenuOpen(false)}
              className="btn-primary flex items-center justify-center gap-2 text-sm w-full"
            >
              Start Journaling
            </Link>
          )}
          <button
            onClick={() => document.documentElement.classList.toggle('dark')}
            className="btn-secondary flex items-center justify-center gap-2 text-sm w-full"
          >
            <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
              <path d="M17.293 13.293A8 8 0 016.707 2.707a8.001 8.001 0 1010.586 10.586z" />
            </svg>
            Toggle Dark Mode
          </button>
          <div className="flex-1 flex items-end">
            <p className="text-text-dark text-sm text-center w-full">
              © 2025 66 Days Journal
            </p>
          </div>
        </div>
      </div>

      {isMenuOpen && (
        <div
          className="md:hidden fixed inset-0 bg-black/50 z-0"
          onClick={toggleMenu}
        ></div>
      )}
    </>
  );
}

export default MobileNav;
